import { render, staticRenderFns } from "./PopupDeliveryCategories.vue?vue&type=template&id=1ef18e98&scoped=true"
import script from "./PopupDeliveryCategories.vue?vue&type=script&lang=js"
export * from "./PopupDeliveryCategories.vue?vue&type=script&lang=js"
import style0 from "./PopupDeliveryCategories.vue?vue&type=style&index=0&id=1ef18e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef18e98",
  null
  
)

export default component.exports